import { defaultClient } from './client';
import { API_BASE_URL, CUSTOMERS_API_PATHS } from '../constants/api';

export const CUSTOMERS = '/customer/customer';

export const getNewCustomers = body => defaultClient.post(CUSTOMERS, body);
export const getNewCustomer = async customerId => {
  const tenantsData = await getNewCustomers({ filters: { customer_id: [customerId] } });
  return tenantsData?.data?.data?.customers.find(customer => customer.id === customerId);
};

export const fetchCustomerPermissions = async customerId => {
  const { data } = await defaultClient.get(`${API_BASE_URL}/me/${customerId}/permissions`);
  return data?.response;
};

export const convertMsspTenantToInherited = ({ parentTenantId, childTenantId }) => {
  return defaultClient.post(CUSTOMERS_API_PATHS.CONVERT_TO_INHERITED, {
    parent_tenant_id: parentTenantId,
    child_tenant_id: childTenantId
  });
};
